export const voidFunc = () => {
  return
}
